import { render } from "./addDaili.vue?vue&type=template&id=99933182&scoped=true"
import script from "./addDaili.vue?vue&type=script&lang=js"
export * from "./addDaili.vue?vue&type=script&lang=js"

import "./addDaili.vue?vue&type=style&index=0&id=99933182&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99933182"]])

export default __exports__